// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aEtamtEXqDb4Wr_be__r{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    height: 100%;
    padding: 16px;
    box-sizing: border-box;
}

.aj46MDn8iGttttmjwBdm{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    box-sizing: border-box;
}
.b8P30RDB1IHGlZOKu6OJ{
    font-size: 24px;
    font-weight: 600;
}

.i_VWGtVrHBOCOGhIjCXu{
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: flex-start;
    justify-content: left;
    box-sizing: border-box;
    
}

.T_5moiSb_Ri87KsUrnvu{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    height: 32px;
    margin-top: 8px;
    box-sizing: border-box;
    width: 100%;
}

.v5f5YUIGhOFVBQv4M9JQ, .l1E_LcGBnNzHCvqxvWQG{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    height: 32px;
    padding: 16px;
    margin-top: 8px;
    box-sizing: border-box;
}

.v5f5YUIGhOFVBQv4M9JQ{
    border: 1px solid var(--border-medium);
}

.l1E_LcGBnNzHCvqxvWQG{
    background-color: var(--background-dark);
    font-size: 20px;
    font-weight: 600;
    color: var(--letter-light);
    border: none
}


.uzewgJB2KrgzI6avNX0e, .wccm93aUKwLN29WKy7JQ, .rzp7XDM23M49GR1nXjbj{
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 16px;
    font-weight: 600;
    height: 24px;
    margin-right: 24px;
}   

.uzewgJB2KrgzI6avNX0e{
    width: 280px;
}

.wccm93aUKwLN29WKy7JQ{
    width: 180px;
}

.rzp7XDM23M49GR1nXjbj{
    width: 180px;
}
`, "",{"version":3,"sources":["webpack://./clientRoot/Static/UserAdminPanel/UserAdminPanel.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,sBAAsB;AAC1B;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,uBAAuB;IACvB,qBAAqB;IACrB,sBAAsB;;AAE1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,aAAa;IACb,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B;AACJ;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB","sourcesContent":[".adminPanel{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n    width: 100%;\n    height: 100%;\n    padding: 16px;\n    box-sizing: border-box;\n}\n\n.adminPanelHeader{\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    box-sizing: border-box;\n}\n.adminPanelTitle{\n    font-size: 24px;\n    font-weight: 600;\n}\n\n.userList{\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    align-items: flex-start;\n    justify-content: left;\n    box-sizing: border-box;\n    \n}\n\n.userListMainRow{\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    height: 32px;\n    margin-top: 8px;\n    box-sizing: border-box;\n    width: 100%;\n}\n\n.user, .userListHeader{\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: flex-start;\n    width: 100%;\n    height: 32px;\n    padding: 16px;\n    margin-top: 8px;\n    box-sizing: border-box;\n}\n\n.user{\n    border: 1px solid var(--border-medium);\n}\n\n.userListHeader{\n    background-color: var(--background-dark);\n    font-size: 20px;\n    font-weight: 600;\n    color: var(--letter-light);\n    border: none\n}\n\n\n.userEmail, .userType, .userStatus{\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    font-size: 16px;\n    font-weight: 600;\n    height: 24px;\n    margin-right: 24px;\n}   \n\n.userEmail{\n    width: 280px;\n}\n\n.userType{\n    width: 180px;\n}\n\n.userStatus{\n    width: 180px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"adminPanel": `aEtamtEXqDb4Wr_be__r`,
	"adminPanelHeader": `aj46MDn8iGttttmjwBdm`,
	"adminPanelTitle": `b8P30RDB1IHGlZOKu6OJ`,
	"userList": `i_VWGtVrHBOCOGhIjCXu`,
	"userListMainRow": `T_5moiSb_Ri87KsUrnvu`,
	"user": `v5f5YUIGhOFVBQv4M9JQ`,
	"userListHeader": `l1E_LcGBnNzHCvqxvWQG`,
	"userEmail": `uzewgJB2KrgzI6avNX0e`,
	"userType": `wccm93aUKwLN29WKy7JQ`,
	"userStatus": `rzp7XDM23M49GR1nXjbj`
};
export default ___CSS_LOADER_EXPORT___;
